import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import RawBackupDetailTable from "components/Table/RawBackupDetailTable";
import { Link, useParams } from "react-router-dom";

export default function RawBackupDetail() {
  const { id } = useParams()

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <RawBackupDetailTable rawBackupId={id} />
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}
